import Vue from 'vue'
export default Vue.mixin({
    data: function () {
        return {
            saving: false
        }
    },
    methods: {
        covertArrayToSelectableObject(items){
            var results = []
            for (const item of items){
                results.push({ value: item.id, label: item.name })
			}
			return results
        },
        
    }
})
